const { CONSTANTS } = require('../../../../config')
const { size } = require('../../../../utils/size')

// ? ******************************************************************************************
// ? ******************************************************************************************

const mod10 = accountNumber => {
  return [...accountNumber]
    // eslint-disable-next-line no-return-assign
    .reduce((acc, curr, idx) => acc += idx % 2 === accountNumber.length % 2 ? +curr * 2 - (+curr > 4 ? 9 : 0) : +curr, 0) % 10 === 0
}

const mod11 = accountNumber => {
  const weight = [2, 3, 4, 5, 6, 7, 8, 9, 10, 1, 2]
  // eslint-disable-next-line no-return-assign
  const remainder = [...accountNumber].reverse().slice(1).reduce((acc, curr, idx) => acc += +curr * weight[idx], 0) % 11
  const checkDigit = remainder === 0 ? remainder : 11 - remainder
  return checkDigit === +accountNumber.slice(-1)
}

/**
 * @param {object} state
 * @param {*} value
 * @param {boolean} validationValue
 * @param {object} formAlternatives
 * @returns {boolean}
 */
function accountNo ({ state, value, validationValue, formAlternatives }) {
  if (!validationValue) return true

  let val = value
  if (!val) return false

  val = value
    .toString()
    .trim()
    .replace(/[^0-9]+/g, '')

  if (!val) return false

  const bankId = state?.lenderComplements?.bank?.value
  const banks = formAlternatives?.banks

  if (!bankId || !banks) return true

  const settings = banks?.find(alt => alt.value === bankId)
  if (!size(settings)) return true

  const { clearingRanges } = settings
  if (!size(clearingRanges)) return true

  let clearingNoLength = 4
  if (
    CONSTANTS.SE?.FIVE_DIGIT_CLEARING_NO?.includes(bankId) ||
    (bankId === CONSTANTS.SE?.BANKS?.SWEDBANK && parseInt(val.substr(0, 1)) === 8)
  ) {
    clearingNoLength = 5
  }

  const clearingNumber = val.substr(0, clearingNoLength)
  const accountNumber = val.substr(clearingNoLength)

  const setting = clearingRanges
    .filter(range => {
      return (
        clearingNumber.slice(0, 4) >= range.from &&
        clearingNumber.slice(0, 4) <= range.to
      )
    })
    .pop()

  if (!setting) return false

  const clearingNumbers = { nordea: [3300, 3782] }

  const algorithms = {
    11: () =>
      clearingNumbers.nordea.includes(+clearingNumber) && accountNumber.length === 10
        ? mod10(accountNumber)
        : mod11(clearingNumber.slice(1, 4) + accountNumber.slice(-8)),
    12: () => mod11(clearingNumber + accountNumber.slice(-8)),
    21: () => mod10(accountNumber.slice(-10)),
    22: () => mod11(accountNumber),
    23: () => mod10((clearingNumber + accountNumber).slice(4)),
    24: () => (clearingNumber + accountNumber).length >= 10 &&
      (clearingNumber + accountNumber).length <= 15 &&
      mod10(clearingNumber) &&
      mod10(accountNumber),
    25: () => mod10(accountNumber.slice(-10))
  }

  return algorithms[setting.algorithm]?.() || false
}

module.exports = { accountNo }
